import { t } from 'i18next';
import { FORGOT_PASSWORD_FORM_FIELDS, FORGOT_PASSWORD_FORM_FIELDS_NAMES } from './forgot-password-form';
import { IConfirmInputs } from '../confirmAccount/confirm-account-form';

export const CHANGE_PASS_INPUTS = ({ showPassword, setShowPassword, showCode, setShowCode }): IConfirmInputs[] => [
  {
    key: FORGOT_PASSWORD_FORM_FIELDS.CODE,
    fieldName: FORGOT_PASSWORD_FORM_FIELDS.CODE,
    label: t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.CODE),
    placeholder: t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.CODE),
    showPassword: showCode,
    setShowPassword: setShowCode,
    additionalClass: 'password-container position-relative col-12 pb-10',
    isPasswordShown: true,
    autoComplete: 'code'
  },
  {
    key: FORGOT_PASSWORD_FORM_FIELDS.NEW_PASSWORD,
    fieldName: FORGOT_PASSWORD_FORM_FIELDS.NEW_PASSWORD,
    label: t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.NEW_PASSWORD),
    placeholder: t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.NEW_PASSWORD),
    showPassword: showPassword,
    setShowPassword: setShowPassword,
    additionalClass: 'password-container position-relative col-12 pb-10',
    isPasswordShown: true,
    isPasswordStrengthShown: true,
    // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
    autoComplete: 'new-password'
  },
  // {
  //   key: FORGOT_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD,
  //   fieldName: FORGOT_PASSWORD_FORM_FIELDS.CONFIRM_PASSWORD,
  //   label: FORGOT_PASSWORD_FORM_FIELDS_NAMES.CONFIRM_PASSWORD,
  //   placeholder: t(FORGOT_PASSWORD_FORM_FIELDS_NAMES.CONFIRM_PASSWORD),
  //   showPassword: showConfirmPassword,
  //   setShowPassword: setShowConfirmPassword,
  //   additionalClass: 'password-container position-relative col-12',
  //   isPasswordShown: true,
  //   autoComplete: 'new-password'
  // }
];
